// Utilities
import { makeStyles, tokens } from "@fluentui/react-components";
/**
 * Hook to get the styles for the SuiteNavLoadingPlaceHolder component.
 */ export const useSuiteNavLoadingPlaceHolderStyles = makeStyles({
    root: {
        height: "48px",
        backgroundColor: tokens.colorNeutralBackground1,
        borderBottomWidth: tokens.strokeWidthThin,
        borderBottomStyle: "solid",
        borderBottomColor: tokens.colorNeutralStroke2,
        flexShrink: 0
    }
});
